"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspenseContentStatus = void 0;
var SuspenseContentStatus;
(function (SuspenseContentStatus) {
    SuspenseContentStatus["ListEmpty"] = "There are no items to display";
    SuspenseContentStatus["ItemEmpty"] = "The item is empty";
    SuspenseContentStatus["ListLoading"] = "The list is loading";
    SuspenseContentStatus["Loading"] = "Loading, please wait";
})(SuspenseContentStatus = exports.SuspenseContentStatus || (exports.SuspenseContentStatus = {}));
//# sourceMappingURL=SuspenseContentStatus.js.map